import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

type Props = {
  feature: string
  onRemoveFeatureCallback: (feature: string) => Promise<void>
}

const Feature = ({ feature, onRemoveFeatureCallback }: Props) => {
  const [removeFeatureInProgress, setRemoveFeatureInProgress] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)

  const onClickRemoveFeature = useCallback(async () => {
    setRemoveFeatureInProgress(true)
    setShowSpinner(true)

    await onRemoveFeatureCallback(feature)
      .catch(() => setRemoveFeatureInProgress(false)).finally(() => setShowSpinner(false))
  }, [feature, onRemoveFeatureCallback])

  return (
    <S.FeatureContainer>
      <S.Feature>{feature}</S.Feature>
      <Button decoration="danger" enabled={!removeFeatureInProgress} text="Remove" onPress={onClickRemoveFeature} showSpinner={showSpinner} />
    </S.FeatureContainer>
  )
}

export default Feature

const S = {
  FeatureContainer: styled.div`
    display: grid;
    grid-template-columns: calc(100% - 50px) auto;
    grid-column-gap: 10px;
    grid-row-gap: 5px;
    align-items: end;
    margin-top: 5px;
    margin-bottom: 5px;
    align-items:center
  `,
  Feature: styled.div`
    margin-right: 2rem;
    font-size: 1.25rem;
  `
}
